import { createAction, props } from "@ngrx/store";
import { DigLitSelfAssessmentResult } from "src/app/_models/DigitalLiteracy";
import { DigLitSelfAssessmentActionTypes } from "src/app/constants/StoreConstants";

export const GetDigLitSelfAssessmentData = createAction(
	DigLitSelfAssessmentActionTypes.GetDigLitSelfAssessmentData,
	props<{learnerId: number}>()
);

export const GetDigLitSelfAssessmentDataSuccess = createAction(
	DigLitSelfAssessmentActionTypes.GetDigLitSelfAssessmentDataSuccess,
	props<{result: DigLitSelfAssessmentResult}>()
);

export const GetDigLitSelfAssessmentDataError = createAction(
	DigLitSelfAssessmentActionTypes.GetDigLitSelfAssessmentDataError,
	props<{error: any}>()
);

export const SaveDigLitSelfAssessment = createAction(
	DigLitSelfAssessmentActionTypes.SaveDigLitSelfAssessment,
	props<{data: DigLitSelfAssessmentResult}>()
);

export const SaveDigLitSelfAssessmentSuccess = createAction(
	DigLitSelfAssessmentActionTypes.SaveDigLitSelfAssessmentSuccess,
	props<{result: boolean}>()
);

export const SaveDigLitSelfAssessmentError = createAction(
	DigLitSelfAssessmentActionTypes.SaveDigLitSelfAssessmentError,
	props<{error: any}>()
);

export const SaveDigLitSelfAssessmentSession = createAction(
	DigLitSelfAssessmentActionTypes.SaveDigLitSelfAssessmentSession,
	props<{data: DigLitSelfAssessmentResult}>()
);

export const SaveDigLitSelfAssessmentSessionSuccess = createAction(
	DigLitSelfAssessmentActionTypes.SaveDigLitSelfAssessmentSessionSuccess,
	props<{result: boolean}>()
);

export const SaveDigLitSelfAssessmentSessionError = createAction(
	DigLitSelfAssessmentActionTypes.SaveDigLitSelfAssessmentSessionError,
	props<{error: any}>()
);

export const SetDigLitState = createAction(
	DigLitSelfAssessmentActionTypes.SetDigLitState,
  props<{state: DigLitSelfAssessmentResult}>()
);

export const SetDigLitStateSuccess = createAction(
	DigLitSelfAssessmentActionTypes.SetDigLitStateSuccess
);

export const ResetDigLitSelfAssessmentState = createAction(
  DigLitSelfAssessmentActionTypes.ResetDigLitSelfAssessmentState
);